export class EditDumpsterUpdateLabelsInput {
  dumpsterId: number;
  labels: number[];

  constructor(dumpsterId: number, labels: number[]) {
    this.dumpsterId = dumpsterId;
    this.labels = labels;
  }
}
